import { render, staticRenderFns } from "./IntegrationSmrtPhone.vue?vue&type=template&id=81a73bde&scoped=true&"
import script from "./IntegrationSmrtPhone.vue?vue&type=script&lang=js&"
export * from "./IntegrationSmrtPhone.vue?vue&type=script&lang=js&"
import style0 from "./IntegrationSmrtPhone.vue?vue&type=style&index=0&id=81a73bde&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "81a73bde",
  null
  
)

export default component.exports